module.exports = __webpack_public_path__ + "static/jobs-section-sky-bg-5126e80ba4160e82d161d06d0c495b36.jpg";